import { useQuery } from 'react-query';
import { queryGet } from './fetch';

export const useIsMaintenanceMode = () => {
  return useQuery<{ isMaintenanceMode: boolean }>(
    ['maintenance'],
    queryGet(`/maintenance`),
  );
};
